export default __webpack_public_path__ + "static/media/undraw_No_data.ffdad94d.svg";